import { isLoading } from 'dmpconnectjsapp-base/helpers/common';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import React from 'react';
import * as yup from 'yup';
import { clearSubSection } from 'dmpconnectjsapp-base/actions';
import { apiSections } from 'dmpconnectjsapp-base/constants';
import commands from 'dmpconnectjsapp-base/actions/config/commands';
import { formatGetMssHpInfosParams } from 'dmpconnectjsapp-base/actions/config/commandParamsFormatters';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getAction } from '../../dmpconnect/actions';
import { existsInText } from '../../dmpconnect/helpers/searchUtils';

const isEmailValid = email => yup.object({ email: yup.string().email().required() }).isValidSync({ email });

const AddressEmailAsyncTypeAhead = ({
  dispatch,
  selectedAddresses,
  onChange,
  getHpSection,
  subSection,
  isInvalid,
  multiple,
  labelKey,
  id,
}) => {
  const ref = React.useRef();

  const searchRecipients = (query) => {
    if (query.trim().length >= 4) {
      if (!isEmailValid(query.trim())) {
        dispatch(clearSubSection(apiSections.MSS_GET_HP_INFOS, subSection));
        const [name, given] = query.trim().split(' ');
        dispatch(getAction(
          commands.getMssHpInfos,
          apiSections.MSS_GET_HP_INFOS,
          formatGetMssHpInfosParams(
            `${name}`,
            given ? `${given}` : undefined,
          ),
          {
            subSection,
          },
        ));
      }
    }
  };
  function checkEmailParts(queryParts) {
    queryParts.forEach((part) => {
      if (isEmailValid(part)) {
        ref.current.clear();
        ref.current.focus();
        onChange([...selectedAddresses, { s_commonName: part, s_mail: part }]);
      }
    });
  }

  const handleInputChange = (event) => {
    if ([' ', ','].includes(event.key)) {
      event.stopPropagation();
      const { value } = event.target;
      const queryParts = value.trim().split(event.key);
      checkEmailParts(queryParts);
    }
  };

  const onBlur = (event) => {
    const queryParts = event.target.value.split(/ |,/);
    checkEmailParts(queryParts);
  };

  const deDuplicateRecipients = () => {
    const recipients = getHpSection.PSList;
    if (!recipients) return [];

    return [...new Map(recipients.map(({ s_commonName, s_mail, s_codeProfession }) => [s_mail, { s_commonName, s_mail, s_codeProfession }])).values()];
  };

  const filterBy = (option, filterProps) => {
    const { s_commonName = '' } = option;
    const { text = '' } = filterProps;
    // return s_commonName.toLowerCase().indexOf(text.replace(/\*/g, '').trim().toLowerCase()) !== -1;
    return existsInText(s_commonName.toLowerCase(), text.replace(/\*/g, '').trim().toLowerCase());
  };

  const list = deDuplicateRecipients();

  return (
    <AsyncTypeahead
      useCache={false}
      inputProps={{ className: 'form-control-sm' }}
      className="custom-typeahead"
      filterBy={filterBy}
      ref={ref}
      id={id}
      isLoading={isLoading(getHpSection)}
      labelKey={labelKey}
      minLength={3}
      onSearch={searchRecipients}
      onKeyDown={event => handleInputChange(event)}
      onBlur={event => onBlur(event)}
      selected={selectedAddresses}
      options={list}
      placeholder="Ajouter un destinataire ..."
      searchText="Recherche en cours ..."
      emptyLabel="Aucun résultat"
      multiple={multiple}
      isInvalid={isInvalid}
      onChange={selection => onChange(selection)}
      renderMenuItemChildren={(option, { text }, index) => (
        <div className="d-flex flex-column mss-recipients">
          <div className="d-flex align-items-center mss-recipient-name">
            <span className={`mr-1 badge-profession badge-profession-${option.s_codeProfession}-1`} />
            {option.s_commonName}
          </div>
          <div className="mss-recipient-email">
            <small className="text-gray-400">
              {option.s_mail}
            </small>
          </div>
          {index < list.length && <hr />}
        </div>
      )}
    />
  );
};

function mapStateToProps(state, props) {
  const {
    dmpconnect: {
      [apiSections.MSS_GET_HP_INFOS]: {
        [props.subSection]: getHpSection,
      } = {},
    },
  } = state;
  return {
    getHpSection,
  };
}

AddressEmailAsyncTypeAhead.propTypes = {
  dispatch: PropTypes.func.isRequired,
  selectedAddresses: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  getHpSection: PropTypes.object,
  subSection: PropTypes.string.isRequired,
  isInvalid: PropTypes.bool,
  multiple: PropTypes.bool,
  labelKey: PropTypes.string,
  id: PropTypes.string.isRequired,
};

AddressEmailAsyncTypeAhead.defaultProps = {
  selectedAddresses: [],
  getHpSection: {},
  isInvalid: false,
  multiple: true,
  labelKey: 's_commonName',
};

const ConnectedAddressEmailAsyncTypeAhead = connect(mapStateToProps)(AddressEmailAsyncTypeAhead);

export default ConnectedAddressEmailAsyncTypeAhead;
